import { render } from "./MWPresentation.vue?vue&type=template&id=e6101918"
import script from "./MWPresentation.vue?vue&type=script&lang=js"
export * from "./MWPresentation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__